<template>
  <div>
    <Router-View />
  </div>
</template>

<script>
export default {
  name: 'MyAccount'
}
</script>

<style></style>
